import * as React from "react";
import { FormGroup } from "../Workflows/RightAside/RightAsideHelpers";
import { BannerInvitation } from "./types";
import Input from "@/components/Input";
import Select from "@/components/Select";
import { FormValidator } from "@velaro/velaro-component-lib";

interface Props {
  onUpdate(invitation: BannerInvitation): void;
  invitation: BannerInvitation;
  errors: Record<string, string>;
}

export default function BannerInvitationEditor({
  invitation,
  errors,
  onUpdate
}: Props) {
  return (
    <>
      <FormGroup label="Message">
        <FormValidator error={errors["message"]}>
          <Input
            value={invitation.message ?? ""}
            onChange={(value) => onUpdate({ ...invitation, message: value })}
          />
        </FormValidator>
      </FormGroup>
      <FormGroup label="Position">
        <Select
          options={[
            { label: "Bottom of page", value: "bottom" },
            { label: "Top of page", value: "top" }
          ]}
          value={invitation.position ?? "bottom"}
          onChange={(value) =>
            onUpdate({ ...invitation, position: value as "top" | "bottom" })
          }
        />
      </FormGroup>
      <FormGroup label="CTA Button Label" tooltipText="The text shown on the call-to-action button">
        <Input
          value={invitation.ctaLabel ?? ""}
          onChange={(value) => onUpdate({ ...invitation, ctaLabel: value })}
        />
      </FormGroup>
    </>
  );
}
